import React from "react"
import styled from "@emotion/styled"
import PropTypes from "prop-types"
import Image from "components/Image"
import htmlFormatting from "utils/htmlFormatting"
import ListTwoCardIcon from "./ListTwoCardIcon"
import ListTwoCardText from "./ListTwoCardText"

const ListTwoCardWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
  z-index: 100;
  background: rgba(28, 28, 28, 0.8);
  &:hover .listContent {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`

const ListTwoCardCover = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  border-radius: 20px;
  top: 0;
  left: 0;
  z-index: -1;
`

const ListContent = styled.div`
  background: rgba(28, 28, 28, 0.8);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  z-index: 1000;
`

const Content = styled.div`
  text-align: center;
  padding: 30px 40px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  height: 100%;
`

const ContentHeading = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  height: auto;
  min-height: 90px;
  margin-bottom: 10px;
`

const Heading = styled.h2`
  font-size: 24px;
  line-height: 36px;
  font-weight: 600;
  margin: 0;
`

const ListTwoContent = ({ title, coverImage, icon, text }) => {
  return (
    <div className="listContent">
      <ListTwoCardWrapper>
        <ListTwoCardCover {...coverImage} />

        <ListContent>
          <Content>
            <ContentHeading>
              <ListTwoCardIcon {...icon} />
              <Heading>{title}</Heading>
            </ContentHeading>
            {text && (
              <ListTwoCardText
                dangerouslySetInnerHTML={{
                  __html: htmlFormatting(text?.childMarkdownRemark?.html),
                }}
              />
            )}
          </Content>
        </ListContent>
      </ListTwoCardWrapper>
    </div>
  )
}

ListTwoContent.propTypes = {
  title: PropTypes.string.isRequired,
  coverImage: PropTypes.object.isRequired,
  icon: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
}

export default ListTwoContent
